import { EndpointQueryParameters } from '../../../types/strapi/strapi'

export const defaultParams: EndpointQueryParameters = {
    sort: ['name:asc', 'version:asc'],
    populate: {
        manufacturer: { fields: ['name'] },
        colorants: { populate: { colorant: { fields: ['name'] } } },
    },
}
